<template>
  <div>
      <!--begin::Form-->
         <div class="form-signin d-flex align-items-stretch flex-column">
              <div class="text-center mb-2">
                <img class="mb-2" src="media/img/femsa.png" alt="" width="120">
                <h3 class="mb-0">Selecciona tu proveedor EJECUTIVO</h3>
                <span>Elige la empresa a la que harás el pago</span>
              </div>
              <div class="d-flex flex-column py-5">
                <b-overlay :show="loading" variant="white" rounded="sm">
                <template v-for="(item, i) in business" >
                 
                  <a v-bind:key="i" class="d-flex align-items-center justify-content-between mb-2 select-partner" href="#" v-on:click.prevent="onSubmit(item)" role="button">
                    <span class="icon"> <img :src="getIcon(item)" alt=""></span>
                    <span class="title">{{item.nombre}}</span>
                    <span class="arrow"><i class="fa fa-chevron-right"></i></span>
                  </a>
                </template>
                </b-overlay>
              </div>
            </div>
        
      <!--end::Form-->
    
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { GET_BUSINESS } from "@/core/services/store/client.module";
import { UPDATE_AUTH } from "@/core/services/store/auth.module";

export default {
  name: "login2",
  data() {
    return {
     loading:true
    };
  },
  mounted () {
    this.getBusiness()
  },
  methods: {
    getBusiness() {
      console.log('auth1 ' + JSON.stringify(this.$store.state.auth));
      console.log('auth2 ' + this.$store.state.user);
      this.$Progress.start();
      this.$store
          .dispatch(GET_BUSINESS, this.$store.state.auth.user)
          .then(()=>{this.$Progress.finish(),this.loading=false});
    },
    onSubmit(item) {
      this.$store
          .dispatch(UPDATE_AUTH, item.codigoEmpresa)
          .then(() => this.$router.push({ name: "dashboard" }));
    },
    getIcon(item){
      let imagen = `/media/img/${item.logo}`; 
      return imagen;
    }
  },
  computed: {
    ...mapState({
      business : state => state.client.business,
      errors: state => state.errors
    })
  }
};
</script>
